import { memdbRequest } from "./index.js";
export var TournamentType;
(function (TournamentType) {
    TournamentType[TournamentType["Unknown"] = 0] = "Unknown";
    TournamentType[TournamentType["Allsvenskan"] = 2] = "Allsvenskan";
    TournamentType[TournamentType["Individual"] = 3] = "Individual";
    TournamentType[TournamentType["SM"] = 4] = "SM";
    TournamentType[TournamentType["SchoolSM"] = 5] = "SchoolSM";
    TournamentType[TournamentType["SvenskaCupen"] = 6] = "SvenskaCupen";
    TournamentType[TournamentType["GrandPrix"] = 7] = "GrandPrix";
    TournamentType[TournamentType["Yes2Chess"] = 8] = "Yes2Chess";
    TournamentType[TournamentType["Schackfyran"] = 9] = "Schackfyran";
})(TournamentType || (TournamentType = {}));
export var PairingSystem;
(function (PairingSystem) {
    PairingSystem[PairingSystem["Berger"] = 1] = "Berger";
    PairingSystem[PairingSystem["Monrad"] = 2] = "Monrad";
    PairingSystem[PairingSystem["NordiskSchweizer"] = 3] = "NordiskSchweizer";
    PairingSystem[PairingSystem["FIDESchweizer"] = 4] = "FIDESchweizer";
    PairingSystem[PairingSystem["Arena"] = 5] = "Arena";
})(PairingSystem || (PairingSystem = {}));
export var GameResult;
(function (GameResult) {
    GameResult[GameResult["NotSet"] = -100] = "NotSet";
    GameResult[GameResult["Postponed"] = 100] = "Postponed";
    GameResult[GameResult["WhiteWin"] = 1] = "WhiteWin";
    GameResult[GameResult["WhiteWinWO"] = 2] = "WhiteWinWO";
    GameResult[GameResult["Schack4anWhiteWinWOValue"] = 5] = "Schack4anWhiteWinWOValue";
    GameResult[GameResult["Schack4anWhiteWinValue"] = 3] = "Schack4anWhiteWinValue";
    GameResult[GameResult["BlackWinWOValue"] = -2] = "BlackWinWOValue";
    GameResult[GameResult["Schack4anBlackWinWOValue"] = -5] = "Schack4anBlackWinWOValue";
    GameResult[GameResult["NoWinWOValue"] = -3] = "NoWinWOValue";
    GameResult[GameResult["BlackWinValue"] = -1] = "BlackWinValue";
    GameResult[GameResult["Schack4anBlackWinValue"] = -4] = "Schack4anBlackWinValue";
    GameResult[GameResult["DrawResultValue"] = 0] = "DrawResultValue";
    GameResult[GameResult["Schack4anDrawResultValue"] = 10] = "Schack4anDrawResultValue";
    GameResult[GameResult["BothNoResultValue"] = -10] = "BothNoResultValue";
    GameResult[GameResult["Schack4anBothNoResultValue"] = -20] = "Schack4anBothNoResultValue";
    GameResult[GameResult["BothWinValue"] = 15] = "BothWinValue";
    GameResult[GameResult["Schack4anBothWinValue"] = 20] = "Schack4anBothWinValue";
})(GameResult || (GameResult = {}));
export const stringFromResult = {
    [GameResult.NotSet]: ["*", "*"],
    [GameResult.Postponed]: ["*", "*"],
    [GameResult.WhiteWin]: ["1", "0"],
    [GameResult.WhiteWinWO]: ["1", "0"],
    [GameResult.Schack4anWhiteWinWOValue]: ["3", "0"],
    [GameResult.Schack4anWhiteWinValue]: ["3", "1"],
    [GameResult.BlackWinWOValue]: ["0", "1"],
    [GameResult.Schack4anBlackWinWOValue]: ["0", "3"],
    [GameResult.NoWinWOValue]: ["0", "0"],
    [GameResult.BlackWinValue]: ["0", "1"],
    [GameResult.Schack4anBlackWinValue]: ["1", "3"],
    [GameResult.DrawResultValue]: ["½", "½"],
    [GameResult.Schack4anDrawResultValue]: ["2", "2"],
    [GameResult.BothNoResultValue]: ["0", "0"],
    [GameResult.Schack4anBothNoResultValue]: ["1", "1"],
    [GameResult.BothWinValue]: ["1", "1"],
    [GameResult.Schack4anBothWinValue]: ["3", "3"],
};
export var AtVenueType;
(function (AtVenueType) {
    AtVenueType[AtVenueType["Here"] = 1] = "Here";
    AtVenueType[AtVenueType["NotHere"] = -1] = "NotHere";
    AtVenueType[AtVenueType["WillNotShowUp"] = -2] = "WillNotShowUp";
})(AtVenueType || (AtVenueType = {}));
export function getTournamentsByDate(params) {
    return memdbRequest.get("/tournament", { params });
}
export function getTournamentsByYearAndType(params) {
    return memdbRequest.get("/tournament", { params });
}
export function getTournament({ tournamentId, params }) {
    return memdbRequest.get(`/tournament/${tournamentId}`, {
        params,
    });
}
export function getTournamentGroup({ groupId, params }) {
    return memdbRequest.get(`/tournament/group/${groupId}`, {
        params,
    });
}
export function getPairingsFromTournaments({ tournamentIds, page, size, includeByes, sortBy, sortOrder, includeWithResults, includeWithoutResults, schema, }) {
    return memdbRequest.get("/tournament/pairings", {
        params: {
            tournamentids: tournamentIds.join(","),
            page,
            size,
            includeByes,
            sortBy,
            sortOrder,
            includeWithResults,
            includeWithoutResults,
            schema,
        },
    });
}
export function getParticipantsFromTournament({ tournamentId, schema, init, }) {
    return memdbRequest.get(`/tournament/${tournamentId}/participants`, {
        params: { schema },
        ...init,
    });
}
export function getParticipantsFromTournamentByMember({ tournamentId, memberId, schema, forceTeamType, init, }) {
    return memdbRequest.get(`/tournament/${tournamentId}/participants/${memberId}`, {
        params: { schema, forceTeamType },
        ...init,
    });
}
export function getPairing({ pairingId, params }) {
    return memdbRequest.get(`/tournament/pairing/${pairingId}`, {
        params,
    });
}
export function getPairingsByTournamentsAndContenders({ tournamentids, partids, ...params }) {
    return memdbRequest.get("/tournament/pairings", {
        params: {
            tournamentids: tournamentids.join(","),
            partids: partids.join(","),
            ...params,
        },
    });
}
export function getGame(pairingId, board, params) {
    return memdbRequest.get(`/tournament/pairing/${pairingId}/${board}`, {
        params,
    });
}
export const updateGame = (game, notifySpelaSchack) => memdbRequest.post(`/tournament/match/${game.pairingid}/${game.board}`, { body: { game, notifySpelaSchack } });
export const createContender = (contender) => memdbRequest.post(`/tournament/group/${contender.groupid}/contender/${contender.partid}/teamnumber/${contender.teamnumber || -1}`, { body: { contender } });
export const updateContender = (contender) => createContender(contender);
export const removeContender = (contender) => memdbRequest.delete(`/tournament/group/${contender.groupid}/contender/${contender.partid}/teamnumber/${contender.teamnumber || -1}`);
export const enterContender = (contenders) => memdbRequest.post("/tournament/enter", {
    body: { contenders },
});
export function getArenaGroupsFromMember(memberId, schema) {
    return memdbRequest.get("/tournament/group/arena", {
        params: { memberId, schema },
    });
}
//# sourceMappingURL=tournament.js.map